import React  from "react";
import { Container } from "@chakra-ui/react";


import { Setting } from "../AiSetting/components/setting";

export default function AiSetting() {

    return (
        <Container maxW="xxl" mt={100}>
            <Setting />
        </Container>
    );
}
